module.exports = __webpack_public_path__ + "3d747d8bf464744eecb91556d86de11b.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-LightItalic.ttf
// module id = 696
// module chunks = 0